<template>
  <div>
    <van-popup v-model="show" :close-on-click-overlay="false">
      <div class="titleInput">
        <input
          v-model="phoneNum"
          class="phone-num"
          type="text"
          placeholder="请输入手机号码"
        />
        <div class="van-hairline--bottom"></div>
        <input
          v-model="verifyNum"
          class="verify-box"
          type="text"
          placeholder="请输入验证码"
        />
        <input
          v-model="btnContent"
          v-on:click="sendcode"
          type="button"
          class="verify-btn"
          :disabled="disabled"
        />
      </div>
      <div class="btn">
        <van-button round type="info" size="large" @click="sendcodeItem()"
          >绑定号码</van-button
        >
      </div>
      <div class="btn">
        <van-button round type="info" size="large" @click="link('/userinfo')"
          >暂不绑定</van-button
        >
      </div>
    </van-popup>
  </div>
</template>
<script>
import { Toast } from "vant";
import API from "../api/index";
import { Cookies } from "../util/index";

export default {
  data() {
    return {
      show: true,
      phoneNum: "", // 手机input的值
      btnContent: "获取验证码",
      verifyNum: "", // 验证码的input 的值
      time: 0, // 发送验证码间隔时间
      disabled: false, // 按钮状态
      resp: "",
    };
  },

  mounted() {},

  watch: {
    verifyNum(curVal, oldVal) {
      if (curVal.length === 6) {
        // 判断它的长度是否等于6
        this.verifyNum = curVal; //让最新的值赋给验证码input
        // this.sendcodeItem()  //然后在请求后台的登陆接口
      }
    },
  },

  methods: {
    link(url) {
      this.$router.push(url);
    },

    sendcode() {
      let reg = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/; // 手机号正则验证
      let phoneNum = this.phoneNum; // 输入手机号的value
      if (!phoneNum) {
        //
        // 未输入手机号
        Toast("请输入手机号码");
        return;
      }
      if (!reg.test(phoneNum)) {
        // 手机号不合法
        Toast("您输入的手机号码不合法，请重新输入");
        return;
        // this.phoneNum = '' // 这个看情况 ，看是否要删除，获取让用用户手机清除
      }

      let time = 60; //判断 时间为60s
      let timer = setInterval(() => {
        if (time === 0) {
          //  当时间等于 0的时候
          clearInterval(timer); //清除时间
          this.disabled = false; // 让按钮的样式 为登陆状态
          this.btnContent = "获取验证码"; // 登陆状态的value文本
          this.verifyNum = ""; // 清除掉验证表单的值
        } else {
          this.btnContent = time + "s后重新获取"; // 若时间大于则展示重新获取
          this.disabled = true; // 判断显示文本的状态
          time--; //将时间的一秒秒
        }
      }, 1000);

      // 此处写后台接口 获取到后台的返回参数来决定
      this.$http({
        method: "post",
        data: {
          userId: Cookies.get("userId"),
          userType: Cookies.get("userType"),
          userTel: phoneNum,
        },
        url: API.sms_url,
      })
        .then(function (resp) {
          if (resp.data.returnCode != "SUCCESS") {
            Toast(resp.data.returnMsg);
            return;
          } else {
            Toast("发送成功，请注意查收");
          }
        })
        .catch((resp) => {
          Toast("网络错误");
        });
    },

    sendcodeItem() {
      const self = this;
      let phoneNum = this.phoneNum;
      let verifyNum = this.verifyNum;
      if (!verifyNum) {
        Toast("请输入验证码");
        return;
      }
      this.$http({
        method: "post",
        data: {
          userId: Cookies.get("userId"),
          userType: Cookies.get("userType"),
          userTel: phoneNum,
          code: verifyNum,
        },
        url: API.phone_url,
      })
        .then(function (resp) {
          if (resp.data.returnCode != "SUCCESS") {
            Toast(resp.data.returnMsg);
            return;
          }
          // this.$router.push({path:'/index'})
          Toast("绑定成功");
          // console.log(111);
          setTimeout(function () {
            // self.$router.push({ path: "/userinfo" });
            history.back();
          }, 3000);
        })
        .catch((resp) => {
          Toast("网络错误");
        });
    },
  },
};
</script>

<style scoped>
.titleInput {
  /* margin: 30px 160px; */
  /* height: 300px; */
  width: 600px;
  font-size: 30px;
}

.titleInput input {
  margin: 60px 20px;
}

.verify-box {
	width: 200px;
}

.verify-btn {
  background: #37c192;
  color: #fff;
  height: 60px;
  padding: 0 10px;
  border-radius: 30px;
  line-height: 60px;
}

.btn {
  margin-top: 20px;
}

/deep/.van-button {
  height: 60px;
  background: #37C192;
  border: #37C192;
}

/deep/.van-button__text {
  font-size: 30px;
}
/deep/.van-popup {
	
border-radius: 10px;
}
</style>


// WEBPACK FOOTER //
// src/pages/phone.vue